import React from 'react'
import { Alert } from 'antd'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'src/store'
import { Button, PageHeader } from 'src/components/Ant'
import history from 'src/config/routes/history'
import { WrapBadge } from './styles'

interface Props {
  error?: string
  title: string
}

function Header({ error = '', title }: Props) {
  const { me, requests } = useSelector((state: ApplicationState) => ({
    me: state.me,
    requests: state.requests
  }))
  const isToodoPayUser = me.user?.in_toodopay ?? false

  return (
    <>
      <PageHeader
        title={title}
        extra={
          <>
            {[597990758089, 299595062723, 559042084949].includes(
              +me.user.tenant_id
            ) && (
              <WrapBadge count={requests.request_totals.total_mocks}>
                <Button
                  onClick={() => history.push('/request-classification')}
                  size="default"
                  title="web.request-to-classify.title"
                  type="dashed"
                />
              </WrapBadge>
            )}
            {isToodoPayUser && (
              <WrapBadge count={requests.request_totals.total_toodopay}>
                <Button
                  data-test-id="single-receipts"
                  onClick={() => history.push('/expense-classification')}
                  size="default"
                  title="web.single-ticket.page-title"
                  type="dashed"
                />
              </WrapBadge>
            )}
            <WrapBadge count={requests.request_totals.total_requests}>
              <Button
                data-test-id="dashboard-my-request"
                onClick={() => history.push('/my-requests')}
                size="default"
                title="web.side.my-requests"
                type="dashed"
              />
            </WrapBadge>
            {!!me.user.auditor && (
              <>
                <WrapBadge count={0}>
                  <Button
                    data-test-id="dashboard-audits"
                    onClick={() => history.push('/audits')}
                    size="default"
                    type="dashed"
                    title="web.side.audits"
                  />
                </WrapBadge>
              </>
            )}
            {!!me.user.role_group.approver.length && (
              <>
                <WrapBadge count={requests.request_totals.total_approvals}>
                  <Button
                    data-test-id="dashboard-approvals"
                    onClick={() => history.push('/approvals')}
                    size="default"
                    title="web.side.approvals"
                    type="dashed"
                  />
                </WrapBadge>
              </>
            )}
            {!!me.user.role_group.checker.length && (
              <>
                <WrapBadge count={requests.request_totals.total_conferences}>
                  <Button
                    data-test-id="dashboard-conferences"
                    onClick={() => history.push('/conferences')}
                    size="default"
                    title="web.side.conferences"
                    type="dashed"
                  />
                </WrapBadge>
              </>
            )}
            {!!me.user.role_group.controller.length && (
              <>
                <WrapBadge count={requests.request_totals.total_closings}>
                  <Button
                    data-test-id="dashboard-closings"
                    onClick={() => history.push('/closings')}
                    size="default"
                    title="web.side.closings"
                    type="dashed"
                  />
                </WrapBadge>
              </>
            )}
          </>
        }
      />
      {error && <Alert message={error} showIcon type="error" />}
    </>
  )
}

export default Header
